<template>
  <div>
  <div class="head affix" id="head" v-html="$store.state.header"></div>
  <nav
    class="navbar is-fixed-top"
    role="navigation"
    aria-label="main navigation"
    :style="navBarBackground"
  >
    <div class="navbar-brand">
    </div>
    <div class="navbar-brand">
      <!-- TODO: icon/dropdown here -->
      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" title="Application selector">
      </a>

      <div v-if="!loggedIn || !activeModule || singleModule" class="navbar-item">
        <img src="../assets/eslogo.png" width="25" height="25" alt="eScholar Uniq-ID">
      </div>
      <div
        v-else
        class="navbar-item has-dropdown"
        :class="{'is-active': isDropdownActive}"
        ref="modulesDropdown"
      >
        <a
          class="navbar-item"
          :style="textColorSecondary"
          @click="toggleDropdownActive"
          v-on-clickaway="away"
          tabindex="0" role="button"
          @keypress.enter.prevent="toggleDropdownActive"
        >
          <font-awesome-icon :icon="['fas', 'th']" class="fa-lg" title="Application selector" />
        </a>

        <div class="navbar-dropdown">
          <div class="is-flex flex-align--center" style="height: 2.9rem; padding: 0.25rem" :style="textColorPrimary">
            <a class="" tabindex="0" role="button" @keypress.enter.prevent="away">
              <font-awesome-icon :icon="['fas', 'th']" class="fa-lg" style="color: #999" title="Application selector" />
            </a>
          </div>

          <div
            class="has-text-black has-text-weight-bold nowrap"
            style="font-size: 12px; margin-bottom: 0.5rem; color: #343a40;"
          >
            Available Applications
          </div>

          <a
            v-for="(module, idx) in activeModules"
            :key="idx"
            class="navbar-item dropdown-item"
            :class="{ 'is-active': activeModule.name === module.name }"
            @click.prevent="goToModule(module, activeModule)"
            tabindex="0" role="button"
            @keypress.enter.prevent="goToModule(module, activeModule)"
          >
            <span style="margin-right: 0.75rem">
              <font-awesome-icon :icon="moduleIcon(module.name)" class="is-size-4"/>
            </span>
            <span>{{ module.displayName }}</span>
          </a>
          <div class="has-text-grey has-text-left" style="margin: 1rem 0; font-size: 12px;">
            Switch between applications by selecting an application above.
          </div>
        </div>
      </div>
      <div class="navbar-item">
        <span
          class="is-uppercase"
          style="font-size: 13.6px"
          :style="textColorPrimary"
        >
          {{ appName }}
        </span>
        <span
          v-if="loggedIn && activeModule"
          class="is-uppercase"
          style="font-size: 13.6px; padding-left: 1rem;"
          :style="textColorPrimary"
        >
          {{ activeModule.displayName }}
        </span>
      </div>
    </div>
    <div class="navbar-menu">
      <div class="navbar-end">
        <div
          v-if="
            loggedIn
            && activeModule
            && activeModule.name === 'locationID'
            && hasModule('LOCID:SRCH:OPTIONS:VIEW')
          "
          class="navbar-item is-hidden-touch"
        >
          <nav-bar-location-search/>
        </div>
        <div class="navbar-item" :style="textColorSecondary">
          <EsProfileDropdown v-if="loggedIn && activeModule"/>
        </div>
      </div>
    </div>
  </nav>
</div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTh,
  faMapMarked,
  faPeopleArrows,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import EsProfileDropdown from '@/components/EsProfileDropdown.vue';
import NavBarLocationSearch from '@/components/NavBarLocationSearch.vue';
import PermissionManager from '@/mixins/PermissionManager';
import RouterViewFocus from '@/mixins/RouterViewFocus';

library.add(
  faTh,
  faMapMarked,
  faPeopleArrows,
  faUsers,
);

export default {
  mixins: [
    clickaway,
    PermissionManager,
    RouterViewFocus,
  ],
  components: {
    EsProfileDropdown,
    NavBarLocationSearch,
  },
  data() {
    return {
      isDropdownActive: false,
    };
  },
  mounted() {
    this.$refs.modulesDropdown.addEventListener('focusout', this.onFocusChange);
  },
  beforeDestroy() {
    this.$refs.modulesDropdown.removeEventListener('focusout', this.onFocusChange);
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      activeModules: 'appModules/activeModules',
      allModules: 'appModules/getAllModules',
      properties: 'propertiesModule/properties',
    }),
    appName() {
      const name = this.properties['GENERAL-APP_NAME'];
      return (!name || name.length === 0) ? 'ESCHOLAR UNIQ-ID' : name;
    },
    loggedIn() {
      return !(this.$store.state.user == null);
    },
    isLocationId() {
      if (this.activeModule && this.activeModule.name === 'locationID') {
        return true;
      }
      return false;
    },
    navBarBackground() {
      let color;
      if (!this.loggedIn || (this.activeModule && this.activeModule.name) === 'directMatch') {
        color = '#000';
      } else if ((this.activeModule && this.activeModule.name) === 'locationID') {
        color = '#ccc';
      } else if ((this.activeModule && this.activeModule.name) === 'personId') {
        color = '#5953a4';
      }
      return `background-color: ${color}`;
    },
    singleModule() {
      return this.activeModules.length === 1;
    },
    textColorPrimary() {
      let color;
      if (this.loggedIn && this.isLocationId) {
        color = '#333';
      } else {
        color = '#fff';
      }
      return `color: ${color}`;
    },
    textColorSecondary() {
      let color;
      if (this.isLocationId) {
        color = '#666';
      } else {
        color = '#fff';
      }
      return `color: ${color}`;
    },
  },
  methods: {
    away() {
      this.isDropdownActive = false;
    },
    onFocusChange(e) {
      const next = e.relatedTarget;

      if (!next || !this.$refs.modulesDropdown.contains(next)) {
        this.isDropdownActive = false;
      }
    },
    toggleDropdownActive() {
      this.isDropdownActive = !this.isDropdownActive;
    },
    goToModule(module, activeModule) {
      if (activeModule.name !== module.name) {
        this.$router.push({ name: module.landing });
        this.toggleDropdownActive();
        this.handleKeyboardNavigation();
      }
    },
    moduleIcon(module) {
      let icon;
      if (module === 'locationID') {
        icon = 'map-marked';
      } else if (module === 'directMatch') {
        icon = 'people-arrows';
      } else if (module === 'personId') {
        icon = 'users';
      }
      return ['fas', icon];
    },
  },
};

</script>
<style lang="sass" scoped>
  // @import "@/sass/custom.sass/"

  @import "@/sass/custom.sass"
  .navbar
    border-bottom: 5px solid $primary
    margin-top: 80px
  .navbar:before
    content: ''
    position: absolute
    background-color: #000
    width: 100%
    height: 1px
    bottom: 0
    left: 0
    z-index: 2
  .navbar-burger
    margin: 0 !important
  .dropdown-item
    padding-left: 24px
    padding-right: 24px
    min-width: 175px
    min-height: 37px
    border-bottom: 1px solid #eee
    color: #444
    &:hover
      text-decoration: none
  // .has-dropdown
  //   .navbar-link
  //     background-color: #000 !important
  //     &:hover
  //       color: #ccc
  .navbar-dropdown
    top: 0
    padding: 0 0.5rem
  .head
    width: 100%
    display: flex
    justify-content: center
    background-color: #fff
  #head.affix
    position: fixed
    top: 0
    width: 100%
    z-index: 11
 </style>
